module.exports = __webpack_public_path__ + "static/media/aito-logo.f73e9dbd.svg";